/* eslint-disable @typescript-eslint/prefer-for-of */
import { Component, OnInit, OnDestroy } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormControl, FormGroup, ValidatorFn, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import {
  AlertItem, AlertType, ComponentModal, Contract,
  EquipmentModel, Manufacturer, MessageModal, Regulation
} from 'src/app/core/models';
import {
  AlertService, ContractConfigColorService, ContractService, EquipmentModelService, ManufacturerService,
  ModalService, RegulationService, StorageService
} from 'src/app/core/services';
import { hasPermission } from 'src/app/core/utils/permission';
import { ViewSelectListComponent } from 'src/app/modals/view-select-list/view-select-list.component';
import moment from 'moment';

@Component({
  selector: 'app-config-general',
  templateUrl: './config-general.component.html',
  styleUrls: ['./config-general.component.sass']
})
export class ConfigGeneralComponent implements OnInit, OnDestroy {
  public loading = false;
  public isLoading = false;
  public allowEdit: boolean;
  public contractId: number;
  public contract: Contract;
  public qrcodeForm: FormGroup;
  public enabledImportForm: FormGroup;
  public regulationForm: FormGroup;
  public regulatorForm: FormGroup;
  public importFilesForm: FormGroup;
  public regulations: Array<Regulation>;
  public enabledRegulations: Array<Regulation>;
  public clientCodesForms: Array<{
    selectionForm: FormGroup;
  }> = [];
  public isValid = true;
  public files = [];
  public newFiles = [];
  public equipments: { [params: string]: Array<EquipmentModel> } = {};
  public equipmentModels: EquipmentModel[] = [];
  public equipmentModelsById: { [params: string]: EquipmentModel } = {};
  public manufacturers: Manufacturer[] = [];
  public manufacturerById: { [params: string]: Manufacturer } = {};
  public manufacturerModelForms: FormGroup[] = [];
  public typeUnfoldRegulation = 'less';
  public typeUnfoldQrCode = 'less';
  public typeUnfoldEquipModel = 'less';
  public typeUnfoldClientCode = 'less';
  public typeUnfoldRegulator = 'less';
  public typeUnfoldFiles = 'less';
  public clientCodesControl: any = [];
  public equipmentModelCateories = [
    { id: 'intrusive', i18n: 'Intrusivo' },
    { id: 'noIntrusive', i18n: 'Não Intrusivo' }
  ];
  private dateValues = {
    endHour: null,
    endDate: null,
    startDate: null,
    startHour: null,
    code: null,
    id: null,
  };
  private subscriptions = [];
  constructor(
    private route: ActivatedRoute,
    private formBuilder: FormBuilder,
    private storageService: StorageService,
    private contractService: ContractService,
    private regulationService: RegulationService,
    private modalService: ModalService,
    private alertService: AlertService,
    private equipmentModelService: EquipmentModelService,
    private manufacturerService: ManufacturerService,
    private contractConfigColorService: ContractConfigColorService
  ) { }

  async ngOnInit() {
    this.loading = true;
    this.contractId = this.route.snapshot.params.contractId;
    await this.getcontract();
    await this.getRegulations();
    await this.getEquipments();
    this.allowEdit = hasPermission('UpdateContractSettings', this.storageService, [this.contract.id]);
    this.setFormValues();
    this.loading = false;
  }

  async getcontract() {
    await this.contractService.getById(this.contractId, true).then((contract) => {
      this.contract = contract;
      this.createForm();
      const files = this.contract.files || [];
      files.forEach(src => {
        this.files.push(this.loadFileDetails(src));
      });
    });
  }

  async getRegulations() {
    let params = {};
    params = { regionId: this.contract.regionId };
    await this.regulationService.getAll(params).then(res => {
      res.map(item => {
        item.shortDescription = `${item.code} - ${item?.shortDescription || item?.description}`;
      });
      this.regulations = res;
      this.enabledRegulations = this.regulations.filter(regulation => this.contract?.regulationIds?.includes(Number(regulation.id))) || [];
    });
  }

  async getEquipments() {
    await this.equipmentModelService.getAll().then(async data => {
      this.equipments = {};
      data.map(equip => {
        equip.type = this.equipmentModelTypeI18n(equip.type);
        if (this.equipments[equip.manufacturerId] == null) {
          this.equipments[equip.manufacturerId] = [];
        }
        equip.category = this.equipmentModelCategoryI18n(equip.category);
        this.equipments[equip.manufacturerId].push(equip);
      });
      await this.manufacturerService.getAll().then(res => {
        this.manufacturers = res;
        this.manufacturers.forEach(manufacturer => {
          this.manufacturerById[manufacturer.id] = manufacturer;
        });
      });
      if (this.contract != null && this.contract.equipmentModelIds != null) {
        const equipmentModelIds = this.contract.equipmentModelIds.sort();
        this.equipmentModelService.list({ 'id[in]': `[${equipmentModelIds}]` }).then(e => {
          this.equipmentModels = e.result;
          e.result.map(item => {
            item.type = this.equipmentModelTypeI18n(item.type);
            item.category = this.equipmentModelCategoryI18n(item.category);
            this.equipmentModelsById[item.id] = item;
          });
        });
      }
      this.isLoading = false;
    });
  }

  equipmentModelTypeI18n(type) {
    let value = type;
    switch (type) {
      case 'fixed':
        value = 'Fixo';
        break;
      case 'speed bump':
        value = 'Lombada eletrônica';
        break;
      case 'portable':
        value = 'Portátil';
        break;
      case 'cftv':
        value = 'CFTV';
        break;
    }
    return value;
  }

  equipmentModelCategoryI18n(category) {
    let value = category;
    switch (category) {
      case 'intrusive':
        value = 'Intrusivo';
        break;
      case 'noIntrusive':
        value = 'Não Intrusivo';
        break;
    }
    return value;
  }

  createForm() {
    this.regulationForm = this.formBuilder.group({
      regulationIds: new FormControl(
        {
          value: this.contract?.regulationIds || [],
          disabled: !this.allowEdit
        }
      ),
      regulationsCheck: new FormBuilder().array([])
    });
    if (this.contract.ContractConfigColors !== undefined && this.contract?.ContractConfigColors?.length > 0) {
      for (const itemColor of this.contract?.ContractConfigColors) {
        this.addRegulation(itemColor);
      }
    }
    this.qrcodeForm = this.formBuilder.group({
      enabledQRCode: new FormControl({ value: this.contract?.QRCode?.enabledQRCode || false }),
      regulationIds: new FormControl({ value: this.contract?.QRCode?.regulationIds || [], disabled: !this.allowEdit })
    });
    this.enabledImportForm = this.formBuilder.group({
      enabledImportFile: [this.contract?.enabledImportFile || false]
    });
    const clientCodes = this.contract.contractClientCodes || [];
    if (clientCodes.length === 0) {
      const form = {
        selectionForm: this.formBuilder.group({
          code: ['', [this.validateDate]],
          startDate: ['', [Validators.required, this.validateDate]],
          startHour: ['00:00:00', [Validators.required, this.validateDate]],
          endDate: [''],
          endHour: ['23:59:59'],
          id: this.uid()
        }),
      };
      this.clientCodesForms.push(form);
    } else {
      for (const client of clientCodes) {
        const code = client.code;
        if (!code || code === '') {
          continue;
        }
        const startDate = moment(client.startsAt).format('YYYY-MM-DD');
        const startHour = moment(client.startsAt).format('HH:mm:ss');
        let endDate = '';
        let endHour = '';
        if (client.endsAt && client.endsAt !== '') {
          endDate = moment(client.endsAt).format('YYYY-MM-DD');
          endHour = moment(client.endsAt).format('HH:mm:ss');
        }
        const form = {
          selectionForm: this.formBuilder.group({
            code: [code, [this.validateDate]],
            startDate: [startDate, [Validators.required, this.validateDate]],
            startHour: [startHour, [Validators.required, this.validateDate]],
            endDate: [endDate, [this.validateDate]],
            endHour: ['23:59:59', [this.validateDate]],
            id: this.uid()
          }),
        };
        const id = form.selectionForm.get('id').value;
        this.clientCodesForms.push(form);
        const findIndex = this.clientCodesControl.findIndex(c => c.id === id);
        if (findIndex < 0) {
          this.clientCodesControl.push({
            id,
            code,
            startDate,
            endDate
          });
        }
      }
      this.validateFormClientCode();
    }
    this.enabledImportForm.valueChanges.subscribe(res => {
      this.isValid = this.enabledImportForm.valid;
    });
    this.regulatorForm = this.formBuilder.group({
      regulatorCode: [this.contract?.regulatorCode || ''],
      regulatorName: [this.contract?.regulatorName || ''],
      regulatorAgentCode: [this.contract?.regulatorAgentCode || ''],
      regulatorAgentName: [this.contract?.regulatorAgentName || ''],
    });
    this.importFilesForm = this.formBuilder.group({
      files: [this.files]
    });
  }

  uid() {
    const a = new Uint32Array(3);
    window.crypto.getRandomValues(a);
    return (performance.now().toString(36) + Array.from(a).map(b => b.toString(36)).join('')).replace(/\./g, '');
  }

  addNew() {
    const form = {
      selectionForm: this.formBuilder.group({
        code: ['', this.validateDate],
        startDate: ['', [Validators.required, this.validateDate]],
        startHour: ['00:00:00', [Validators.required, this.validateDate]],
        endDate: [''],
        endHour: ['23:59:59'],
        id: this.uid()
      }),
    };
    this.clientCodesForms.push(form);
    this.validateFormClientCode();
  }

  validateFormClientCode() {
    this.clientCodesForms.map((client, index) => {
      client.selectionForm.valueChanges.subscribe(res => {
        let startDateOld;
        let endDateOld;
        const clientOld = this.clientCodesForms[index - 1];
        if (clientOld) {
          startDateOld = clientOld.selectionForm.get('startDate');
          endDateOld = clientOld.selectionForm.get('endDate');
        }
        this.isValid = client.selectionForm.valid;
        const id = client.selectionForm.get('id');
        const code = client.selectionForm.get('code');
        const startDate = client.selectionForm.get('startDate');
        const endDate = client.selectionForm.get('endDate');
        if (this.clientCodesControl.length === 0 && moment(startDate.value).isValid() && !moment(endDate.value).isValid()) {
          this.isValid = true;
        }
        if (this.isValid && moment(startDate.value).isValid() &&
          moment(endDate.value).isValid() && startDate.value > endDate.value) {
          this.isValid = false;
          endDate.setValidators([Validators.required, this.validateDate]);
          endDate.setErrors({ incorrect: true });
        }

        const findIndex = this.clientCodesControl.findIndex(c => c.id === id.value);
        if (findIndex < 0) {
          this.clientCodesControl.push({
            id: id.value,
            code: code.value,
            startDate: startDate.value,
            endDate: endDate.value
          });
        } else {
          this.clientCodesControl[findIndex] = {
            id: id.value,
            code: code.value,
            startDate: startDate.value,
            endDate: endDate.value
          };
        }
        if (!startDate.valid && moment(startDate.value).isValid() &&
          moment(endDate.value).isValid() && startDate.value <= endDate.value) {
          if (startDateOld && !startDateOld.valid && moment(startDateOld.value).isValid() &&
            moment(endDateOld.value).isValid() && startDateOld.value <= endDateOld.value) {
            this.isValid = true;
          }
        }
        if (endDateOld && !moment(endDateOld.value).isValid()) {
          this.isValid = false;
          endDateOld.setValidators([Validators.required, this.validateDate]);
        }
        if (this.clientCodesControl.length > 1) {
          const clientCodesOuthers = this.clientCodesControl.filter(c => c.id !== id.value);
          for (const clientCodeOuther of clientCodesOuthers) {
            const startDateNow = new Date(startDate.value);
            const startDateOldValue = new Date(clientCodeOuther.startDate);
            const endDateOldValue = new Date(clientCodeOuther.endDate);
            if (moment(startDateNow).isValid() && moment(startDateOldValue).isValid() && moment(endDateOldValue).isValid()) {
              if (this.isValid && moment(startDateNow).isBetween(startDateOldValue, endDateOldValue, 'date', '[]')) {
                this.isValid = false;
                break;
              }
            }
            if (clientCodeOuther.startDate === startDate.value || clientCodeOuther.endDate === startDate.value) {
              this.isValid = false;
              break;
            }
            if (!this.isValid &&
              moment(clientCodeOuther.startDate).isValid() && moment(startDate.value).isValid() &&
              (clientCodeOuther.startDate !== startDate.value ||
                (moment(clientCodeOuther.endDate).isValid() && clientCodeOuther.endDate !== startDate.value))) {
              this.isValid = true;
              break;
            }
          }
        }
      });
    });
  }

  removeClientForm(indexClientForms, forceUpate = true) {
    this.clientCodesForms.splice(indexClientForms, 1);
    if (forceUpate) {
      this.confirmation();
    }
  }

  validateDate = () => {
    let message = null;
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for (let i = 0; i < this.clientCodesForms.length; i++) {
      const client = this.clientCodesForms[i];
      const lastClient = this.clientCodesForms[i - 1];
      const dateControls: any = {};
      const dateControlsOld: any = {};
      const newDateValues = {};
      for (const key of Object.keys(this.dateValues)) {
        dateControls[key] = client.selectionForm.get(key);
        newDateValues[key] = dateControls[key].value;
        if (lastClient) {
          dateControlsOld[key] = lastClient.selectionForm.get(key);
        }
      }
      const id = dateControls.id.value;
      const code = dateControls.code.value;
      const startHour = (dateControls.startHour.value).split(':');
      const endHour = (dateControls.endHour.value).split(':');
      const startDate = moment(dateControls.startDate.value)
        .set({ hour: startHour[0], minute: startHour[1], second: startHour[2], millisecond: 59 }).format();
      const endDate = moment(dateControls.endDate.value)
        .set({ hour: endHour[0], minute: endHour[1], second: endHour[2], millisecond: 59 }).format();
      if (code === '' && startDate === '') {
        continue;
      }
      if (code && !moment(startDate).isValid()) {
        dateControls.startDate.pristine = false;
        dateControls.startDate.setErrors({ incorrect: true });
        message = {
          requiredAll: 'Required startDate fields'
        };
      } else if ((!dateControls.startDate.valid || !dateControls.code.valid) && code && moment(startDate).isValid()) {
        dateControls.startDate.pristine = true;
        dateControls.code.clearValidators();
        dateControls.code.updateValueAndValidity();
      }
      if (moment(startDate).isValid() && moment(endDate).isValid() && endDate < startDate) {
        dateControls.endDate.pristine = false;
        dateControls.endDate.setErrors({ incorrect: true });
        message = {
          invalidPeriod: 'Fields startHour greater than endHour'
        };
      }
      if (lastClient && i > 1) {
        const startDateOld = lastClient.selectionForm.get('startDate');
        const endDateOld = lastClient.selectionForm.get('endDate');
        const startDateNow = new Date(dateControls.startDate.value);
        const startDateOldValue = new Date(startDateOld.value);
        const endDateOldValue = new Date(endDateOld.value);
        if (moment(startDateNow).isBetween(startDateOldValue, endDateOldValue, 'date', '[]')) {
          dateControls.startDate.pristine = false;
          dateControls.startDate.setErrors({ incorrect: true });
          message = {
            requiredInvalidPeriod: 'Required startDate fields'
          };
        }
      }
      if (moment(startDate).isValid() && moment(endDate).isValid() && startDate && endDate < startDate) {
        dateControls.endDate.pristine = false;
        dateControls.endDate.setErrors({ incorrect: true });
        message = {
          isBiggerThan: 'Fields startHour greater than endHour'
        };
      }
      if (lastClient && !moment(dateControlsOld.endDate.value).isValid()) {
        dateControlsOld.endDate.pristine = false;
        dateControlsOld.endDate.setErrors({ incorrect: true });
        message = {
          requiredEndDate: 'Required startDate fields'
        };
      }
    }
    return message;
  };

  setFormValues() {
    this.regulationForm.get('regulationIds').patchValue(this.contract.regulationIds || []);
    this.qrcodeForm.get('enabledQRCode').patchValue(this.contract?.QRCode?.enabledQRCode || false);
    this.qrcodeForm.get('regulationIds').patchValue(this.contract?.QRCode?.regulationIds || []);
  }

  openViewSelectListModal(inputValueIds, title, condition, list) {
    if (condition) {
      const data = { title, inputValueIds, list };
      this.modalService.show(new ComponentModal(ViewSelectListComponent, data));
    }
  }

  loadFileDetails(url) {
    const name = this.getFileName(url);
    const type = this.getFileType(name);
    const data = {
      detail: {
        type,
        name
      },
      data: url
    };
    return data;
  }

  getFileType(name) {
    let type = name.split('.').pop();
    switch (type) {
      case 'png':
      case 'jpg':
      case 'jpeg':
      case 'gif':
        type = `image/${type}`;
        break;
      default:
        return type;
    }
    return type;
  }

  getFileName(src) {
    const decoded = decodeURIComponent(src || '');
    const result = decoded.match(/[^/\\&\?]+\.\w{3,4}(?=([\?&].*$|$))/) || '';
    return result !== '' ? result[0] : result;
  }

  addNewModel() {
    const formAddNew = this.formBuilder.group({
      manufacturerId: ['', [Validators.required]],
      equipmentModelId: ['', [Validators.required, this.duplicateNameValidator()]],
      equipmentModelType: [''],
      equipmentModelInstrument: [''],
      equipmentModelCategory: ['']
    });
    this.manufacturerModelForms.push(formAddNew);

    let sub = formAddNew.get('manufacturerId').valueChanges
      .subscribe(_ => {
        formAddNew.patchValue({ equipmentModelId: '' });
      });
    this.subscriptions.push(sub);

    sub = formAddNew.get('equipmentModelId').valueChanges
      .subscribe(value => {
        if (this.equipmentModels.indexOf(value) >= 0) {
          formAddNew.patchValue({ equipmentModelId: '' });
        }
        if (formAddNew.get('equipmentModelId').value !== '') {
          formAddNew.get('equipmentModelType').patchValue(formAddNew.get('equipmentModelId').value);
          formAddNew.get('equipmentModelCategory').patchValue(formAddNew.get('equipmentModelId').value);
        }
      });
    this.subscriptions.push(sub);
  }

  removeForm(form) {
    const index = this.manufacturerModelForms.indexOf(form);
    if (index >= 0) {
      this.manufacturerModelForms.splice(index, 1);
    }
  }

  removeModel(modelId) {
    const index = this.contract.equipmentModelIds.findIndex(e => e === modelId);
    if (index >= 0) {
      this.contract.equipmentModelIds.splice(index, 1);
    }
  }

  duplicateNameValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      if (this.equipmentModels.some(e => e.id === control.value)) {
        // eslint-disable-next-line @typescript-eslint/naming-convention
        return { DuplicateName: { value: control.value } };
      }
      return null;
    };
  }

  async unfoldMoreOrLessRegulation() {
    this.typeUnfoldRegulation = this.typeUnfoldRegulation === 'more' ? 'less' : 'more';
    setTimeout(() =>
      document
        .getElementById(`userIdHistoryUnfoldRegulation`)
        .scrollIntoView({ behavior: 'smooth' }
        ), 355);
  }

  unfoldMoreOrLessQrCode() {
    this.typeUnfoldQrCode = this.typeUnfoldQrCode === 'more' ? 'less' : 'more';
    setTimeout(() =>
      document
        .getElementById(`userIdHistoryUnfoldQrCode`)
        .scrollIntoView({ behavior: 'smooth' }
        ), 355);
  }

  unfoldMoreOrLessEquipModel() {
    this.typeUnfoldEquipModel = this.typeUnfoldEquipModel === 'more' ? 'less' : 'more';
    setTimeout(() =>
      document
        .getElementById(`userIdHistoryUnfoldEquipModel`)
        .scrollIntoView({ behavior: 'smooth' }
        ), 355);
  }

  unfoldMoreOrLessClientCode() {
    this.typeUnfoldClientCode = this.typeUnfoldClientCode === 'more' ? 'less' : 'more';
    setTimeout(() =>
      document
        .getElementById(`userIdHistoryUnfoldClientCode`)
        .scrollIntoView({ behavior: 'smooth' }
        ), 355);
  }

  unfoldMoreOrLessRegulator() {
    this.typeUnfoldRegulator = this.typeUnfoldRegulator === 'more' ? 'less' : 'more';
    setTimeout(() =>
      document
        .getElementById(`userIdHistoryUnfoldRegulator`)
        .scrollIntoView({ behavior: 'smooth' }
        ), 355);
  }

  unfoldMoreOrLessFiles() {
    this.typeUnfoldFiles = this.typeUnfoldFiles === 'more' ? 'less' : 'more';
    setTimeout(() =>
      document
        .getElementById(`userIdHistoryUnfoldFiles`)
        .scrollIntoView({ behavior: 'smooth' }
        ), 355);
  }

  addRegulation(item = null) {
    const reglationItem = this.formBuilder.group({
      regulationId: [item?.regulationId || '', [Validators.required]],
      color: [item?.color || '#808080', [Validators.required]],
      id: [item?.id || null, [Validators.required]]
    });
    (this.regulationForm.controls.regulationsCheck as FormArray).push(reglationItem);
  }

  updateColor(e, idx) {
    const regulations = this.regulationForm.get('regulationsCheck') as FormArray;
    regulations.at(idx).get('color').setValue(e.target.value);
  }

  checkDoubleRegulation(e, idx) {
    const regulations = this.regulationForm.get('regulationsCheck') as FormArray;
    const findRegulation = regulations.value.filter(r => r.regulationId === e);
    if (findRegulation.length > 1) {
      regulations.at(idx).get('regulationId').setValue('');
    }
    return;
  }

  removeRegulation(i: number, id: number) {
    if (id) {
      this.modalService.show(new MessageModal('Remover Enquadramento', 'Deseja remover este enquadramento?', true))
        .then(() => {
          this.contractConfigColorService.removeContractConfigColor(this.contractId, id).then((res) => {
            (this.regulationForm.controls.regulationsCheck as FormArray).removeAt(i);
            this.alertService.show(new AlertItem('ContractConfiged', AlertType.success));
          });
        })
        .catch(err => {
          if (err.error && err.error.type === 'brandInternalNotDelete') {
            this.alertService.show(new AlertItem('ModelNotDelete', AlertType.danger, false, 5000));
          }
        });
    } else {
      (this.regulationForm.controls.regulationsCheck as FormArray).removeAt(i);
    }
  }

  async confirmation() {
    let success = false;
    try {
      this.loading = true;
      // this.contract.regulationIds = this.regulationForm.get('regulationIds').value;
      const regulationIds = [];
      const contractConfigColors = [];
      for (const itemRegulation of this.regulationForm.get('regulationsCheck').value) {
        const itemColor: any = {
          regulationId: itemRegulation.regulationId,
          contractId: this.contractId,
          color: itemRegulation.color
        };
        if (itemRegulation?.id) {
          itemColor.id = itemRegulation.id;
        }
        contractConfigColors.push(itemColor);
        regulationIds.push(itemRegulation.regulationId);
      }
      this.contract.regulationIds = regulationIds;
      this.contract.ContractConfigColors = contractConfigColors;
      const qrCode = {
        enabledQRCode: this.qrcodeForm.get('enabledQRCode').value || false,
        regulationIds: this.qrcodeForm.get('regulationIds').value || [],
        maxAmount: 0
      };
      if (!qrCode.enabledQRCode) {
        qrCode.regulationIds = [];
      }
      this.contract.QRCode = qrCode;
      if (this.contract.equipmentModelIds === null) {
        this.contract.equipmentModelIds = [];
      }
      for (const form of this.manufacturerModelForms) {
        const value = form.get('equipmentModelId').value;
        if (!this.contract.equipmentModelIds.includes(value)) {
          this.contract.equipmentModelIds.push(value);
        }
      }
      const fields: any = this.dateValues;
      fields.code = null;
      this.contract.contractClientCodes = [];
      for (const client of this.clientCodesForms) {
        const dateControls: any = {};
        const newDateValues = {};
        for (const key of Object.keys(fields)) {
          dateControls[key] = client.selectionForm.get(key);
          newDateValues[key] = dateControls[key].value;
        }
        if (!dateControls.code.value || dateControls.code.value === '') {
          continue;
        }
        const code = (dateControls.code.value);
        let startHour = null;
        let startsAt = null;
        if (moment(dateControls.startDate.value).isValid()) {
          if (dateControls.startHour.value && dateControls.startHour.value !== '') {
            startHour = (dateControls.startHour.value).split(':');
            startsAt = moment(dateControls.startDate.value)
              .set({ hour: startHour[0], minute: startHour[1], second: startHour[2], millisecond: 59 }).format();
          }
        }
        let endHour = null;
        let endsAt = null;
        if (moment(dateControls.endDate.value).isValid()) {
          if (dateControls.endHour.value && dateControls.endHour.value !== '') {
            endHour = (dateControls.endHour.value).split(':');
            endsAt = moment(dateControls.endDate.value)
              .set({ hour: endHour[0], minute: endHour[1], second: endHour[2], millisecond: 59 }).format();
          }
        }
        const clientForm = {
          code,
          startsAt,
          endsAt
        };
        if (!clientForm.startsAt) {
          delete clientForm.startsAt;
        }
        if (!clientForm.endsAt) {
          delete clientForm.endsAt;
        }
        let isAddContractClientCode = true;
        const indexClient = this.contract.contractClientCodes.findIndex(c => c.code === clientForm.code);
        if (indexClient >= 0) {
          isAddContractClientCode = false;
          this.removeClientForm(indexClient);
        }
        if (isAddContractClientCode) {
          this.contract.contractClientCodes.push(clientForm);
        }
      }
      const filesContract = (this.importFilesForm.get('files').value || []).map(f => f.isNew === true ? f.detail : f.data);
      if (filesContract.length > 0) {
        this.contract.files = filesContract.map(file => typeof file === 'string' ? this.getFileName(file) : file);
      } else {
        this.contract.files = filesContract;
      }
      for (const key of Object.keys(this.contract)) {
        if (!this.contract[key]) {
          delete this.contract[key];
        }
      }
      const regulatorCode = this.regulatorForm.get('regulatorCode').value;
      const regulatorName = this.regulatorForm.get('regulatorName').value;
      const regulatorAgentCode = this.regulatorForm.get('regulatorAgentCode').value;
      const regulatorAgentName = this.regulatorForm.get('regulatorAgentName').value;
      this.contract.regulatorCode = '';
      this.contract.regulatorName = '';
      this.contract.regulatorAgentCode = '';
      this.contract.regulatorAgentName = '';
      if (regulatorCode && regulatorCode !== '') {
        this.contract.regulatorCode = regulatorCode;
      }
      if (regulatorName && regulatorName !== '') {
        this.contract.regulatorName = regulatorName.normalize('NFD').replace(/[\u0300-\u036f]/g, '');;
      }
      if (regulatorAgentCode && regulatorAgentCode !== '') {
        this.contract.regulatorAgentCode = regulatorAgentCode;
      }
      if (regulatorAgentName && regulatorAgentName !== '') {
        this.contract.regulatorAgentName = regulatorAgentName.normalize('NFD').replace(/[\u0300-\u036f]/g, '');;
      }
      this.contract.name = this.contract.name.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
      this.contract.enabledImportFile = this.enabledImportForm.get('enabledImportFile').value || false;
      if (this.contract.contractClientCodes.length === 0) {
        this.contract.contractClientCodes = [{
          code: '',
          startsAt: '',
          endsAt: ''
        }];
      }
      delete this.contract.updatedAt;
      await this.contractService.update(this.contract, true).then(res => {
        success = true;
        this.manufacturerModelForms = [];
      }).catch(error => {
        success = false;
        throw error;
      }).finally(async () => {
        await this.contractService.getById(this.contractId, true).then((contract) => {
          this.contract = contract;
          this.createForm();
          const files = this.contract.files || [];
          files.forEach(src => {
            this.files.push(this.loadFileDetails(src));
          });
        });
      });
    } catch (err) {
      console.error('Failed config-general', err);
    } finally {
      if (success) {
        this.alertService.show(new AlertItem('ContractConfiged', AlertType.success));
        setTimeout(() => {
          location.reload();
        }, 1500);
      } else {
        this.loading = false;
        this.alertService.show(new AlertItem('ContractConfigError', AlertType.danger));
      }
    }
  }

  ngOnDestroy() {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }
}
